import styles from "./toolbox-components.module.css";

// Thumbnail grid

export interface Thumbnail {
  id: string;
  src: string;
  alt: string;
}
export interface ThumbnailGridProps {
  thumbnails: Thumbnail[];
  selectedThumbnailId: string;
  onSelectThumbnail: (thumbnailId: string) => void;
}
export const ThumbnailGrid = (props: ThumbnailGridProps) => {
  return (
    <div className={styles.thumbnailGridContainer}>
      {props.thumbnails.map((thumbnail) => (
        <img
          key={thumbnail.id}
          src={thumbnail.src}
          className={
            thumbnail.id === props.selectedThumbnailId
              ? styles.thumbnailSelected
              : styles.thumbnail
          }
          onClick={() => props.onSelectThumbnail(thumbnail.id)}
          alt={thumbnail.alt}
        />
      ))}
    </div>
  );
};
